import styled from 'styled-components'
import { clamp } from '@styles/utils/conversion.style'
import { font } from '@styles/vars/font.style'
import { colors } from '@styles/vars/colors.style'
import { mq } from '@styles/vars/media-queries.style'

export const InformationMain =  styled.section`
  background-color: ${props => props.backgroundColor};
  h3, p {
    ${clamp('font-size', 22, 32)}
    ${clamp('margin-bottom', 20, 40)}
    font-family: ${font.serif.family};
  }
`

export const Heading =  styled.h2`
  font-family: ${font.sans.family};
  font-weight: ${font.sans.weight.extrabold};
  ${clamp('font-size', 22, 35)};
`